const normalizeInlineStyle = (style) => {
    if (!style)
        return undefined;
    if (Array.isArray(style)) {
        return style.reduce((acc, part) => {
            if (part && typeof part === 'object' && !Array.isArray(part)) {
                Object.assign(acc, part);
            }
            return acc;
        }, {});
    }
    if (typeof style === 'object') {
        const entries = Object.entries(style).filter(([k]) => Number.isNaN(Number(k)));
        return Object.fromEntries(entries);
    }
    return undefined;
};
export default normalizeInlineStyle;
